import { render } from "./UsersTable.vue?vue&type=template&id=932eae4a"
import script from "./UsersTable.vue?vue&type=script&lang=js"
export * from "./UsersTable.vue?vue&type=script&lang=js"
script.render = render

export default script